import { render, staticRenderFns } from "./BCleaningStatusBadge.vue?vue&type=template&id=4b2238f4&"
import script from "./BCleaningStatusBadge.vue?vue&type=script&lang=js&"
export * from "./BCleaningStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports